import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { JoinPlatformButton } from './JoinPlatformButton';
export function FinalCTA() {
  return <Section background="charcoal" className="text-center py-32" data-id="element-135" data-mp="c7twfnvkiyvm">
      <div className="max-w-3xl mx-auto" data-id="element-136" data-mp="8573tkr2p9xd">
        <FadeIn data-id="element-137" data-mp="84e2izavvcmm">
          <h2 className="text-5xl md:text-6xl font-serif text-ivory mb-8" data-id="element-138" data-mp="83vw59uibi0z">
            Join the Next Era of Wellness
          </h2>
          <p className="text-xl text-ivory/70 mb-12 font-light" data-id="element-139" data-mp="h5vdy4dciq4z">
            Whether you are seeking care, providing care, or investing in the
            future of care — there is a place for you here.
          </p>
        </FadeIn>

        <FadeIn delay={200} className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-140" data-mp="qwq25ea5jzt2">
          <JoinPlatformButton className="w-full sm:w-auto bg-purple-600 text-white hover:bg-purple-700" data-id="element-141" data-mp="14tdb6ffdqgfc" />
          <a href="/practitioners" data-id="element-142" data-mp="zua830iymka0">
            <Button variant="outline" size="lg" className="w-full sm:w-auto border-ivory text-ivory hover:bg-ivory hover:text-charcoal" data-id="element-143" data-mp="2c56c66kxs9kg">
              Apply to Network
            </Button>
          </a>
        </FadeIn>
      </div>
    </Section>;
}